/// <amd-module name="Test/Analytics/TestAnalyticsTrendChart/Actions/TestInsightsTrendChartActionsCreator" />
import { AnnouncementActions } from "Test/Analytics/Common/Actions/AnnouncementActions";
import * as CommonTypes from "Test/Analytics/Common/Types";
import * as TcmPerfScenarios from "Test/Analytics/Common/Utils/TCMPerfScenarios";
import * as TcmTelemetryConstants from "Test/Analytics/Common/Utils/TcmTelemetryConstants";
import { publishEvent } from "Test/Analytics/Common/Utils/TelemetryService";
import { TestInsightsTrendChartActions } from "Test/Analytics/TestAnalyticsTrendChart/Actions/TestInsightsTrendChartActions";
import * as Resources from "Test/Analytics/TestAnalyticsTrendChart/Resources";
import { TestInsightsTrendChartsSource } from "Test/Analytics/TestAnalyticsTrendChart/Sources/TestInsightsTrendChartsSource";
import { ITrendChartData } from "Test/Analytics/TrendChartCommon/Types";
import * as Utils_String from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPerformanceService } from "VSS/Platform/Performance";

export class TestInsightsTrendChartActionsCreator {
    private _chartsSource: TestInsightsTrendChartsSource;
    private _perfService: IVssPerformanceService;
    constructor(
        private _actions: TestInsightsTrendChartActions,
        private _announcementActions: AnnouncementActions,
        private _pageContext: IVssPageContext
    ) {
        this._chartsSource = new TestInsightsTrendChartsSource(_pageContext);
        this._perfService = _pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    }

    public updateTrendChart(
        testReportContext: CommonTypes.ITestReportContext,
        testContext: CommonTypes.ITestContext,
        confValues: CommonTypes.IReportConfiguration
    ): Promise<void> {
        this._perfService.startScenario(TcmPerfScenarios.TestAX_TestTrendChart, false);

        this._actions.updateConfigurationValuesAction.invoke(confValues);
        return this._chartsSource.queryTrendChartData(testReportContext, testContext, confValues).then(
            (chartData: ITrendChartData) => {
                this._actions.updateTrendChartAction.invoke(chartData);
                this._announcementActions.announceAction.invoke(
                    Utils_String.localeFormat(Resources.TrendChartLoaded, CommonTypes.Metric[CommonTypes.Metric.ResultCount])
                );

                this._perfService.endScenario(TcmPerfScenarios.Area, TcmPerfScenarios.TestAX_TestTrendChart, false);

                const telemetryData: { [key: string]: string | number } = {
                    [TcmTelemetryConstants.Duration]: CommonTypes.Period[confValues.period].toString(),
                    [TcmTelemetryConstants.IsCached]: String(chartData.isCachedData)
                };

                publishEvent(this._pageContext, TcmTelemetryConstants.featureTestAX_TestTrendChart, telemetryData, testReportContext, confValues);
            },
            (error: Error) => {
                this._actions.onError.invoke(error);
                this._perfService.endScenario(TcmPerfScenarios.Area, TcmPerfScenarios.TestAX_TestTrendChart, false, undefined, { status: "error" });
            }
        );
    }
}
